import Page from "src/components/Report/Page";
import MiniSignalChart from "./components/MiniSignalChart";
import { useLocation } from "react-router-dom";

export default function Page17() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let EVC;
    if (JSON.parse(localStorage?.data)?.[jobId]?.EVC) {
        EVC = JSON.parse(localStorage?.data)?.[jobId]?.EVC
    } else {
        EVC = []
    }
    let KSA;
    if (JSON.parse(localStorage?.data)?.[jobId]?.KSA) {
        KSA = JSON.parse(localStorage?.data)?.[jobId]?.KSA
    } else {
        KSA = []
    }
    return (
        <Page pageNumber={17}>
            <div className="font-bold text-lg">
                شاخص های رفتاری (EVC)
            </div>
            <p className="text-black text-justify">
                شاخص‌های رفتاری (EVC) مجموعه‌ای از ویژگی‌ها، نگرش‌ها و رفتارهای فردی هستند که کیفیت تعاملات و عملکرد شاغل را در محیط کاری نشان می‌دهند. این شاخص‌ها شامل نظم، آراستگی، روحیه همکاری، رعایت شئونات، تعهد سازمانی و حسن رفتار با دیگران می‌باشند. ارزیابی این شاخص‌ها نقش مهمی در سنجش تناسب فرد با فرهنگ سازمانی دارد. درج این بخش مبنایی برای انتخاب، آموزش و ارتقاء کارکنان بر اساس رفتار حرفه‌ای فراهم می‌سازد.
            </p>
            <div className="flex flex-col">

                {
                    Object.keys(EVC).sort(function (a, b) { return EVC[b].value - EVC[a].value }).map((key, index) => {
                        if (EVC[key].value >= 1) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniSignalChart value={EVC[key].value} />
                                    <div className=" px-2">{key}</div>
                                    {/* <div className="text-[13px]">{EVC[key].desc}</div> */}
                                </div>
                            )
                        }
                    })
                }
            </div>
            <div className="font-bold text-lg mt-2">
                شاخص های مبتنی بر شایستگی (KSA)
            </div>
            <p className="text-black text-justify">
                شاخص‌های KSA شامل دانش (Knowledge)، مهارت (Skill) و نگرش (Attitude) مورد نیاز برای انجام مؤثر وظایف شغلی هستند. این شاخص‌ها مبنای طراحی مسیرهای آموزشی، ارزیابی عملکرد و توسعه حرفه‌ای کارکنان محسوب می‌شوند. در تحلیل شغل، KSA به شناسایی قابلیت‌های تخصصی و رفتاری مرتبط با شغل کمک می‌کند. درج این بخش امکان انطباق بهتر فرد با الزامات شغلی و اهداف سازمانی را فراهم می‌سازد.
            </p>
            <div className="flex flex-col">

                {
                    Object.keys(KSA).sort(function (a, b) { return KSA[b].value - KSA[a].value }).map((key, index) => {
                        if (KSA[key].value >= 1) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniSignalChart value={KSA[key].value} />
                                    <div className=" px-2">{key}</div>
                                    {/* <div className="text-[13px]">{KSA[key].desc}</div> */}
                                </div>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}